var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V16H16V176H496Z",
    fill: "#E32D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496V336H16V496H496Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 346V166H16V346H496Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.821 247.797L224.513 247.452V242.715L236.821 247.797V247.797Z",
    fill: "#FF9C10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.771 246.415L224.513 240.346V232.452C224.513 232.452 223.077 232.649 223.282 231.07C223.35 227.78 232.29 237.073 236.872 240.1L236.77 246.416L236.771 246.415Z",
    fill: "#FF9C10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.685 266.992L209.532 267.189V251.598L179.991 250.225L183.685 267L183.685 266.992Z",
    fill: "#FF9C10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.452 245.478L209.941 248.044L209.737 236.992L182.863 226.729L182.452 245.478L182.452 245.478Z",
    fill: "#FF9C10"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.992 223.38L209.122 233.248L212.139 230.217C212.139 230.217 210.196 228.929 210.292 227.744C210.329 226.545 212.247 226.363 212.284 225.062C212.319 223.863 210.111 223.719 210.087 222.52C209.943 221.22 211.789 219.826 211.789 219.826L192.711 203.84L187.992 223.379L187.992 223.38Z",
    fill: "#FF9C10"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.668 267.19H299.385L299.18 251.994L329.13 249.822L326.668 267.191L326.668 267.19Z",
    fill: "#FF9C10"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M327.336 245.238C326.991 242.771 326.63 240.31 326.042 237.891C325.256 234.652 324.252 231.465 323.034 228.359C322.944 228.13 322.809 227.92 322.717 227.691L299.388 237.197L299.599 248.449L327.336 245.238L327.336 245.238Z",
    fill: "#FF9C10"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M311.392 208.705C306.738 212.131 302.084 215.556 297.431 218.981C297.454 219.964 298.461 220.721 298.738 221.662C299.383 222.982 298.102 224.149 297.309 225.083C296.667 225.943 298.051 226.382 298.512 226.891C299.525 227.903 298.642 229.49 297.563 230.079C298.863 230.837 299.52 232.254 299.806 233.65C306.773 230.122 313.74 226.594 320.708 223.066C318.208 217.94 315.091 213.092 311.392 208.705L311.392 208.705Z",
    fill: "#FF9C10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.519 248.141L284.211 247.648L284.415 243.107L272.518 248.141L272.519 248.141Z",
    fill: "#FF9C10"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.51 245.675L272.46 240.544C272.46 240.544 283.536 230.923 285.895 229.146C285.895 231.12 284.614 232.649 284.614 232.649V240.149L272.51 245.675L272.51 245.675Z",
    fill: "#FF9C10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M200.719 202.457C200.923 202.654 213.148 215.725 213.148 215.725C213.491 214.487 216.31 214.298 219.181 214.496C222.054 214.693 224.343 214.311 224.343 216.285C224.343 218.258 222.886 217.978 222.886 219.36C222.886 220.741 225.07 220.625 225.07 222.4C225.07 224.176 223.486 223.814 223.478 225.189C223.473 226.326 225.13 226.387 225.13 226.387L236.771 237.242L236.822 225.647L212.821 189.432L200.719 202.458L200.719 202.457Z",
    fill: "#FF9C10"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.923 188.745C220.105 189.271 236.18 220.729 236.18 220.729C236.18 220.729 236.362 191.205 239.102 189.623L234.536 181.539L219.923 188.745L219.923 188.745Z",
    fill: "#FF9C10"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M272.392 185.35C270.369 192.158 268.346 198.965 266.322 205.774C268.215 205.993 270.126 206.052 272.028 205.95C273.737 206.093 272.405 207.653 272.496 208.577C272.488 212.763 272.48 216.95 272.471 221.137C278.189 211.306 283.908 201.474 289.625 191.644C285.681 189.64 281.495 188.151 277.282 186.789C275.675 186.237 274.043 185.759 272.392 185.35L272.392 185.35Z",
    fill: "#FF9C10"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M293.741 193.883C286.668 204.468 279.596 215.052 272.523 225.637C272.514 229.713 272.505 233.789 272.497 237.865C277.221 233.49 281.969 229.137 286.679 224.747C287.573 223.515 283.842 222.912 285.707 221.41C287.396 220.892 287.683 218.235 285.904 217.724C284.438 215.629 287.23 214.519 288.989 214.748C291.438 214.857 293.962 214.229 296.357 214.891C297.676 216.119 298.891 213.037 300.184 212.344C302.743 209.838 305.305 207.335 307.834 204.802C303.665 200.572 298.905 196.897 293.741 193.883L293.741 193.883Z",
    fill: "#FF9C10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M239.009 317.174C233.792 317.46 228.593 320.888 226.156 322.723C230.531 324.587 235.201 326.042 240.17 327.039C248.087 328.333 256.004 328.323 263.922 328.323C265.214 328.165 266.493 327.986 267.748 327.784L284.427 322.312C284.427 322.312 276.404 317.156 270.045 317.379C263.684 317.602 259.391 323.659 254.262 323.211C249.134 322.764 247.08 317.174 239.695 317.174C239.464 317.174 239.239 317.161 239.009 317.174L239.009 317.174Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.71395
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.716 312.981L303.495 313.376C303.495 313.376 295.29 304.89 285.647 304.692C276.006 304.494 278.673 308.64 271.288 309.231C263.904 309.823 262.056 304.889 255.287 305.086C248.518 305.283 244.619 309.231 239.492 309.429C234.363 309.626 227.799 304.494 223.901 304.692C220.003 304.889 206.053 310.613 206.053 310.613L208.72 312.981L208.716 312.981Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M196.614 302.121L313.545 302.516C315.39 299.951 307.8 293.833 300.826 293.24C295.081 293.437 290.98 298.963 286.261 299.161C281.543 299.358 276.21 293.437 270.875 293.635C265.542 293.832 260.003 299.161 254.669 299.161C249.336 299.161 245.438 293.437 238.669 293.437C231.9 293.437 228.822 299.753 223.693 299.358C218.564 298.963 214.051 293.043 209.128 293.043C204.205 293.043 196 300.148 194.359 299.753C192.718 299.358 196.409 302.713 196.616 302.121L196.614 302.121Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M241.821 291.236L267.923 291.221C268.126 291.023 262.079 282.548 254.876 283.145C246.851 283.348 241.401 291.236 241.821 291.236V291.236Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M325.055 290.628H289.338C289.338 290.628 293.961 288 295.221 285.574C297.532 286.787 296.901 288 301.524 288.202C306.146 288.404 310.558 283.149 314.971 283.351C319.383 283.553 325.056 290.83 325.056 290.628L325.055 290.628Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M184.301 290.628H220.019C220.019 290.628 215.396 288 214.136 285.574C211.825 286.787 212.456 288 207.833 288.202C203.212 288.404 198.799 283.149 194.386 283.351C189.974 283.553 184.301 290.83 184.301 290.628L184.301 290.628Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186.97 279.825L212.407 280.022C212.407 280.022 210.766 276.668 210.562 272.523C203.995 270.353 198.662 277.259 193.944 277.457C189.227 277.654 184.304 272.523 184.304 272.523L186.97 279.825L186.97 279.825Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M322.775 279.825L297.337 280.022C297.337 280.022 298.979 276.668 299.183 272.523C305.749 270.353 311.082 277.259 315.801 277.457C320.518 277.654 325.441 272.523 325.441 272.523L322.775 279.825L322.775 279.825Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M248.307 280.023L261.229 279.629C261.229 279.629 261.435 275.879 254.665 275.879C247.896 275.879 248.511 280.221 248.306 280.023L248.307 280.023Z",
    fill: "#083D9C",
    stroke: "#083D9C",
    strokeWidth: 1.60979
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M241.534 239.559L268.409 246.467V209.559C256.099 210.152 245.844 187.06 267.588 185.482C246.254 182.521 243.791 187.85 241.33 193.573L241.535 239.559H241.534Z",
    fill: "#CE1126",
    stroke: "#630810",
    strokeWidth: 1.60971,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M247.505 272.921C241.659 282.235 226.033 279.473 222.379 272.97C221.284 272.672 221.932 232.852 221.932 232.852C221.932 232.852 220.186 232.087 220.105 230.862C220.025 229.626 222.479 229.514 222.479 227.931C222.479 226.35 219.973 226.969 219.923 225.378C219.934 223.855 222.598 224.065 222.479 222.659C222.338 221.073 219.495 221.308 219.374 219.846C219.282 218.686 221.408 217.673 221.999 217.151C221.617 217.169 220.024 217.128 220.014 217.123C218.522 217.152 217.029 217.182 215.538 217.211C212.358 217.214 215.593 217.878 215.546 219.643C215.517 220.796 213.934 221.564 213.792 222.566C213.742 223.595 216.058 224.318 216.087 225.554C216.113 226.656 213.812 226.731 213.894 227.755C214.037 229.488 215.933 229.87 215.904 230.919C215.875 231.967 213.353 232.367 213.347 233.203C213.435 234.821 213.712 274.149 213.712 274.149C217.73 294.184 240.929 299.28 247.505 272.92L247.505 272.921Z",
    fill: "#CE1126",
    stroke: "#630810",
    strokeWidth: 1.60971,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M262.798 272.921C268.644 282.235 284.269 279.472 287.923 272.97C289.018 272.672 288.371 232.852 288.371 232.852C288.371 232.852 290.117 232.086 290.197 230.862C290.277 229.626 287.977 229.514 287.977 227.931C287.977 226.349 290.33 226.969 290.38 225.377C290.369 223.855 287.909 223.967 288.028 222.559C288.169 220.975 290.1 221.16 290.21 219.699C290.302 218.44 288.997 217.673 288.407 217.151C288.789 217.169 290.279 217.128 290.289 217.123C291.781 217.152 293.273 217.182 294.765 217.211C297.945 217.214 294.71 217.878 294.757 219.643C294.785 220.796 296.369 221.564 296.511 222.566C296.561 223.595 294.245 224.318 294.216 225.554C294.19 226.656 296.492 226.731 296.408 227.755C296.265 229.488 294.37 229.87 294.399 230.919C294.427 231.967 296.95 232.367 296.956 233.203C296.868 234.821 296.591 274.149 296.591 274.149C292.572 294.184 269.375 299.28 262.798 272.92L262.798 272.921Z",
    fill: "#CE1126",
    stroke: "#630810",
    strokeWidth: 1.60971,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M240.512 274.687C242.769 273.502 244.82 272.319 246.256 269.555L237.434 269.752C237.434 269.752 233.333 272.121 231.281 274.687H240.512L240.512 274.687Z",
    fill: "#630810",
    stroke: "#630810",
    strokeWidth: 2.32604,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M269.022 274.687C266.766 273.502 264.715 272.319 263.279 269.555L272.1 269.752C272.1 269.752 276.202 272.121 278.253 274.687H269.022L269.022 274.687Z",
    fill: "#630810",
    stroke: "#630810",
    strokeWidth: 2.32604,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M224.508 266.4L285.231 266.597Z",
    fill: "#630810"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.508 266.4L285.231 266.597",
    stroke: "#630810",
    strokeWidth: 2.32604,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M227.379 252.391L234.56 261.667Z",
    fill: "#630810"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M227.379 252.391L234.56 261.667",
    stroke: "#630810",
    strokeWidth: 2.32604,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M227.379 261.664L235.175 252.586Z",
    fill: "#630810"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M227.379 261.664L235.175 252.586",
    stroke: "#630810",
    strokeWidth: 2.32604,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.484 251.791L231.279 257.514Z",
    fill: "#630810"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M231.484 251.791L231.279 257.514",
    stroke: "#630810",
    strokeWidth: 2.32604,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPf);
export default __webpack_public_path__ + "static/media/PF.5474da98943a2cda027e4a3c2e0798a0.svg";
export { ForwardRef as ReactComponent };